<div class="material-datatables">
  <table id="vendorsTable" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
    style="width:100%">
    <thead>
      <tr>
        <th>ID</th>
        <th>Rep Name</th>
        <th>Company Name</th>
        <th>Title</th>
        <th>Name</th>
        <th>City</th>
        <th>Date</th>
        <th>Status</th>
        <th class="disabled-sorting text-right">Actions</th>
      </tr>
    </thead>

    <tbody>
      <tr id="user{{item.id}}" *ngFor="let item of vendors">
        <td>{{item.id}}</td>
        <td>    {{item.managedByString || getRepName(item.managedBy)}}</td>
        <td>{{item.companyLinked != null ? item.companyLinked.name : ''}}</td>
        <td>{{item.ocupation}}</td>
        <td>{{item.name + ' ' + item.surname}}</td>
        <td>{{item.city}}</td>
        <td>{{item.createdAt | date:'MM/dd/yyyy'}}</td>
        <td>
          <button class="btn {{item.activo == 1 ? 'btn-success' : 'btn-danger'}} btn-sm" (click)="userActive(item.id)">
            <i class="material-icons">power_settings_new</i> &nbsp; <span>{{item.activo == 1 ? 'Active' :
              'Inactive'}}</span>
          </button>
        </td>
        <td class="text-right">
          <a [routerLink]="['/pages/user', item.id]" class="btn btn-link btn-info btn-just-icon"><i
              class="material-icons">remove_red_eye</i></a>

          <!-- <a (click)="deleteFolderfirst(item.id)" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a> -->
        </td>
      </tr>
    </tbody>
  </table>
</div>